export const Y2021Config = {
    year: '2021',
    eventHeaderLogo: '/assets/images/landing-page/2021/logo-iTAX2021.png',
    eventHeaderDate: '12 - 14 พฤศจิกายน 2564 เมกาบางนา ชั้น 1',
    eventHeaderBgImg: '/assets/images/landing-page/2021/iTAX2021.jpg',
    eventHeaderBgImgHeight: '290px',
    eventDetailBgImg: '/assets/images/landing-page/landing-jobs.jpg',
    eventActivities: [
        {
            img: '/assets/images/landing-page/2021/2021event01.jpg',
            title: 'วางแผนภาษีแบบตัวต่อตัว ฟรี',
            content: 'ทีมงาน iTAX และผู้เชี่ยวชาญกฎหมายภาษีจะช่วยคำนวณและวางแผนภาษีให้คุณอย่างใกล้ชิดแบบตัวต่อตัว โดยไม่เสียค่าใช้จ่ายใดๆ ทั้งสิ้น เพื่อให้คุณรู้ได้ทันทีว่าจะต้องทำอะไรต่อภายในงบประมาณที่คุณเลือกเอง',
            linkTitle: 'Subscribe มางาน iTAX 2021',
            linkUrl: 'https://www.facebook.com/events/613754679645652'
        },
        {
            img: '/assets/images/landing-page/iTAXteam2.jpg',
            title: 'ค้นหาตัวเลือกลดหย่อนภาษีที่เหมาะกับคุณ',
            content: 'คุณสามารถเปิดบัญชีกองทุนลดหย่อนภาษีได้ฟรี พร้อมขอรับคำปรึกษาการลงทุนจากนักวางแผนการเงินมืออาชีพของ iTAX ได้ฟรีด้วยเช่นกัน และค้นหาประกันลดหย่อนภาษีที่ให้ผลประโยชน์สูง ทั้งประกันชีวิต ประกันสุขภาพ และประกันบำนาญ พร้อมข้อเสนอพิเศษช่วงสิ้นปีจาก Official Partner ของ iTAX',
            linkTitle: 'Subscribe มางาน iTAX 2021',
            linkUrl: 'https://www.facebook.com/events/613754679645652'
        },
        {
            img: '/assets/images/landing-page/2021/2021event03.jpg',
            title: 'ร่วมกิจกรรมเพื่อผู้เสียภาษีโดยเฉพาะ',
            content: 'เปิดพื้นที่กิจกรรมให้ทุกคนได้มาร่วมแสดงพลังในฐานะผู้เสียภาษีอย่างเต็มที่ เช่น บอร์ดโหวต “อยากให้ภาษีไปไหน” หรือบอร์ดเขียนแสดงความเห็นในฐานะผู้เสียภาษี และกิจกรรมอื่นๆ อีกมาก',
            linkTitle: 'Subscribe มางาน iTAX 2021',
            linkUrl: 'https://www.facebook.com/events/613754679645652'
        },
        {
            img: '/assets/images/landing-page/img-eventvenue.jpg',
            title: 'สถานที่',
            content: 'ศูนย์การค้า เมกาบางนา',
            content2: 'ชั้น 1 ลาน Fashion Galleria (ลานหน้า Zara และ H&M)',
            content3: '12 - 14 พฤศจิกายน 2564 เวลา 10.00 น. - 22.00 น.',
            linkTitle: 'ดูแผนที่',
            linkUrl: '//goo.gl/maps/gWUwi6XZmvjy5nSUA',
            isLocation: true
        }
    ]
};
